import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  CreateSalaryStructureGraphQLRequest,
  CreateSalaryStructureGraphQLResponse,
} from '../types';

const createSalaryStructureMutation = gql`
  mutation PayrollCreateSalaryStructure($input: PayrollCreateSalaryStructureInput!) {
    payrollCreateSalaryStructure(input: $input) {
      data {
        id
      }
      code
      success
      message
    }
  }
`;

const createSalaryStructure = (queryVariables: CreateSalaryStructureGraphQLRequest) => {
  return graphQLApi<CreateSalaryStructureGraphQLResponse, CreateSalaryStructureGraphQLRequest>({
    query: createSalaryStructureMutation,
    queryVariables,
  });
};

export default createSalaryStructure;
